"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _component = _interopRequireDefault(require("@loadable/component"));

var _clsx = _interopRequireDefault(require("clsx"));

var _ReactReferences = _interopRequireDefault(require("./ReactReferences02.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DetectButton = (0, _component.default)(function () {
  return import("./DetectButton");
});
var Typography = (0, _component.default)(function () {
  return import("@micado-digital/react-ui/components/Typography");
});

var ReactReferences02 = function ReactReferences02(_ref) {
  var _ref$buttonColor = _ref.buttonColor,
      buttonColor = _ref$buttonColor === void 0 ? "secondary" : _ref$buttonColor,
      _ref$buttonSize = _ref.buttonSize,
      buttonSize = _ref$buttonSize === void 0 ? "medium" : _ref$buttonSize,
      _ref$buttonVariant = _ref.buttonVariant,
      buttonVariant = _ref$buttonVariant === void 0 ? "contained" : _ref$buttonVariant,
      elements = _ref.elements,
      endIcon = _ref.endIcon,
      _ref$headlineComponen = _ref.headlineComponent,
      headlineComponent = _ref$headlineComponen === void 0 ? "h2" : _ref$headlineComponen,
      _ref$headlineVariant = _ref.headlineVariant,
      headlineVariant = _ref$headlineVariant === void 0 ? "h2" : _ref$headlineVariant,
      headlineVariants = _ref.headlineVariants,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 24 : _ref$iconSize,
      _ref$linkVariant = _ref.linkVariant,
      linkVariant = _ref$linkVariant === void 0 ? "body1" : _ref$linkVariant,
      linkVariants = _ref.linkVariants,
      startIcon = _ref.startIcon,
      title = _ref.title;
  var css = (0, _ReactReferences.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-references-02"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("mco-references-02__container", css.container)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("mco-references-02__headline-wrapper", css.headlineWrapper)
  }, /*#__PURE__*/_react.default.createElement(Typography, {
    className: (0, _clsx.default)("mco-references-02__headline", css.headline),
    component: headlineComponent,
    dangerouslySetInnerHTML: {
      __html: title
    },
    variant: headlineVariant,
    variants: headlineVariants
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("mco-references-02__list", css.list)
  }, elements === null || elements === void 0 ? void 0 : elements.map(function (item) {
    var id = item.id;
    return /*#__PURE__*/_react.default.createElement(DetectButton, _extends({}, item, {
      buttonColor: buttonColor,
      buttonSize: buttonSize,
      buttonVariant: buttonVariant,
      endIcon: endIcon,
      iconSize: iconSize,
      key: id,
      linkVariant: linkVariant,
      linkVariants: linkVariants,
      startIcon: startIcon
    }));
  }))));
};

ReactReferences02.propTypes = {
  buttonColor: _propTypes.default.string,
  buttonSize: _propTypes.default.string,
  buttonVariant: _propTypes.default.string,
  elements: _propTypes.default.array,
  endIcon: _propTypes.default.object,
  headlineComponent: _propTypes.default.string,
  headlineVariant: _propTypes.default.string,
  headlineVariants: _propTypes.default.object,
  iconSize: _propTypes.default.number,
  linkVariant: _propTypes.default.string,
  linkVariants: _propTypes.default.object,
  startIcon: _propTypes.default.object,
  title: _propTypes.default.string
};
var _default = ReactReferences02;
exports.default = _default;